<div class="cerrix-collapsing-box" [class.is-collapsed]="isCollapsed">
    @if (titleTemplate) {
        <div class="cerrix-collapsing-box-title-bar">
            <ng-container
                [ngTemplateOutlet]="titleTemplate"
                [ngTemplateOutletContext]="{
                    toggleCollapse: toggleCollapse,
                    isCollapsed: isCollapsed,
                }"
            ></ng-container>
        </div>
    } @else {
        <div class="cerrix-collapsing-box-title-bar" (click)="toggleCollapse()">
            <ng-container>
                <div class="cerrix-collapsing-box-title">{{ boxTitle }}</div>
                <div class="cerrix-collapsing-box-collapse-button">
                    <i class="fas fa-chevron-{{ isCollapsed ? 'down' : 'up' }}"></i>
                </div>
            </ng-container>
        </div>
    }

    @if (!isCollapsed) {
        <div class="cerrix-collapsing-box-content">
            <ng-container
                [ngTemplateOutlet]="contentTemplate"
                [ngTemplateOutletContext]="{
                    toggleCollapse: toggleCollapse,
                    isCollapsed: isCollapsed,
                }"
            ></ng-container>
        </div>
    }
</div>
